import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function operacaoabastecimento(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@operacaoabastecimento/DELETE_OPERACAOABASTECIMENTO_CLIENTE':
      case '@operacaoabastecimento/FIND_OPERACAOABASTECIMENTO':
      case '@operacaoabastecimento/UPDATE_OPERACAOABASTECIMENTO':
      case '@operacaoabastecimento/DELETE_OPERACAOABASTECIMENTO':
      case '@operacaoabastecimento/STORE_OPERACAOABASTECIMENTO':
      case '@operacaoabastecimento/OPERACAOABASTECIMENTOS_IN_REQUEST': {
        draft.loading = true;
        // draft.find = null;
        break;
      }

      case '@operacaoabastecimento/SUCCESS_REMOVE':
      case '@operacaoabastecimento/SUCCESS_REMOVE_FORM':
      case '@operacaoabastecimento/FAILED_REQUEST': {
        draft.loading = false;
        // draft.find = null;
        break;
      }

      case '@operacaoabastecimento/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.operacaoabastecimentos;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@operacaoabastecimento/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.operacaoabastecimento;
        break;
      }

      case '@operacaoabastecimento/RECORD_FILTERING': {
        draft.loading = true;
        draft.find = null;
        draft.params = { ...draft.params, ...action.payload.params };
        break;
      }
      case '@operacaoabastecimento/SET_LOADING': {
        draft.loading = true;
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
